import React from "react";
import "moment/locale/pt-br";
import { Button, Dropdown, Menu, Icon } from "antd";

import { ModuleHeader } from '~/components/ModuleHeader';

export const Header = ({
  showDrawer,
}) => {
  return (
    <>
      <ModuleHeader
        breadcrumbs={['Compliance', 'Recuperação Tributária']}
        title="Recuperação Tributária"
        center={
          <Dropdown
            trigger={['click']}
            overlay={
              <Menu>
                <Menu.Item key="new" onClick={function() { showDrawer(); }}>
                  <Icon type="plus" /> Novo Cadastro
                </Menu.Item>
              </Menu>
            }
          >
            <Button icon="plus" shape="circle" />
          </Dropdown>
        }
      />
    </>
  );
};
